/**
 * @prettier
 * @flow
 */
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import React from 'react';
import { actions } from 'src/reducers';
import { useAction } from 'src/utils/react/useAction';
import { translate } from 'src/utils/translate/translate';

export function CopyToClipboardButton({ tooltip, text, getText }: Props) {
    const showAppSnackBarMessage = useAction(actions.showAppSnackBarMessage);

    return (
        <>
            <Tooltip title={tooltip || translate('Copy to Clipboard')}>
                <IconButton
                    onClick={async event => {
                        event.stopPropagation();
                        await navigator.clipboard.writeText(getText ? getText() : text ?? '');
                        showAppSnackBarMessage({ message: translate('Copied!'), autoHideDuration: 1000 });
                    }}
                >
                    <FilterNoneIcon />
                </IconButton>
            </Tooltip>
        </>
    );
}

type Props = {
    tooltip?: string,
    text?: string,
    getText?: Function,
};
